

  <div class="row">
    <div class="col-8 ">
      <input
        [(ngModel)]="url"
        (input)="changeVideoLink()"
        type="text"
        class="form-control"
        id="url"
        name="url"
        placeholder="Inserisci un link valido"
      />
    </div>
    <div class="col-4 ">
      <button
        type="button"
        class="btn btn-danger"
        (click)="deleteVideo()"
        [disabled]="!url">
        {{ "Elimina" | translate }}
      </button>
    </div>
  </div>

<small *ngIf="urlError" class="text-danger small" role="alert">{{ "L'url non è valida" | translate }}</small>
<div class="mt-2 mb-2"> <span>{{ "Oppure" | translate }}</span> </div>
